/**
 * https://ui.shadcn.com/docs/components/input
 */
import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-[42px] w-full rounded-full border border-borderLight bg-transparent px-4 py-1 text-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-subtle focus-visible:border-brandTangerine focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brandTangerine aria-invalid:border-redDark hover:border-borderDark hover:disabled:border-borderLight disabled:cursor-not-allowed disabled:bg-backgroundLight disabled:text-textSubtle",
          className,
        )}
        onContextMenu={(e) => e.preventDefault()}
        ref={ref}
        {...props}
      />
    );
  },
);

export const inputStyles = "h-10 rounded-full border-borderLight px-4 !text-xs w-full";
Input.displayName = "Input";

export { Input };
